import { environment } from '../environments/environment.prod';

export const AUTH_TOKEN_KEY = 'authToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const IMPERSONATE_TOKEN = 'impersonateToken';

export const MENU_HEIGHT = 155;

export const SOCKET_SERVER_URL = environment.socketUrl ?? `http://localhost:8089`;

export const GENDER_OPTIONS = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Prefer not to answer', value: 'prefer not to say' },
  { label: 'Other', value: 'other' },
];
